import { module } from 'angular'
import facturacionConfiguracionModule from './configuracion/index.js'
import facturacionFacturasModule from './facturas/index.js'
import facturacionMainModule from './main/index.js'

export default module('_facturacion', [
  facturacionConfiguracionModule,
  facturacionFacturasModule,
  facturacionMainModule,
  'facturacion.templates',
])



// WEBPACK FOOTER //
// ./src/facturacion/module.js